import { render, staticRenderFns } from "./WorldMapSelect.vue?vue&type=template&id=bfa459ac"
import script from "./WorldMapSelect.vue?vue&type=script&lang=js"
export * from "./WorldMapSelect.vue?vue&type=script&lang=js"
import style0 from "./WorldMapSelect.vue?vue&type=style&index=0&id=bfa459ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports